// 订单卡片公共组件
import React from 'react';
import { useTranslation } from '@/i18n';
import './OrderCard.scss';
import messagePng from "@/assets/images/message.png"

const OrderCard = ({ order, type, onAction, onChat }) => {
  const t = useTranslation();
  // 获取订单状态文本
  const getOrderStatusText = (status) => {
    const statusMap = {
      0: t('orderCard.status.cancelled'),
      1: t('orderCard.status.calling'),
      2: t('orderCard.status.pickingUp'),
      3: t('orderCard.status.arrivedPickup'),
      4: t('orderCard.status.passengerBoarded'),
      5: t('orderCard.status.completed'),
      6: t('orderCard.status.driverCollected'),
    };
    return statusMap[status] || t('orderCard.status.unknown');
  };

  // 获取按钮配置
  const getActionButton = (status) => {
    switch (parseInt(status)) {
      case 2:
        return { text: t('orderCard.action.arrivedPickup'), nextStatus: 3 };
      case 3:
        return { text: t('orderCard.action.passengerBoarded'), nextStatus: 4 };
      case 4:
        return { text: t('orderCard.action.orderEnd'), nextStatus: 5 };
      default:
        return null;
    }
  };

  return (
    <div className="order-card">
      <div className="order-header">
        <span className="order-number">{order.orderId}</span>
        <span className="order-status">
          {type === 'hall' 
            ? (order.paymentStatus === 1 ? t('orderCard.payment.paid') : t('orderCard.payment.unpaid'))
            : getOrderStatusText(order.orderStatus)
          }
        </span>
      </div>

      <div className="order-info">
        <div className="info-item">
          <span className="label">{t('orderCard.label.departureTime')}:</span>
          <span className="value">{order.departureTime}</span>
        </div>
        
        {order.flightInfo && (
          <div className="info-item">
            <span className="label">{t('orderCard.label.flightInfo')}:</span>
            <span className="value">{order.flightInfo}</span>
          </div>
        )}
        
        <div className="info-item">
          <span className="label">{t('orderCard.label.departure')}:</span>
          <span className="value">{order.startName}</span>
        </div>
        
        <div className="info-item">
          <span className="label">{t('orderCard.label.destination')}:</span>
          <span className="value">{order.destinationName}</span>
        </div>
        
        <div className="info-item">
          <span className="label">{t('orderCard.label.phone')}:</span>
          <span className="value">{order.passengerPhone}</span>
        </div>
        
        {order.passengerRemark && (
          <div className="info-item">
            <span className="label">{t('orderCard.label.remark')}:</span>
            <span className="value">
              {order.adult > 0 && ` ${t('orderCard.remark.adults', { count: order.adult })}`}
              {order.children > 0 && ` ${t('orderCard.remark.children', { count: order.children })}`}
              {order.childSeat > 0 && ` ${t('orderCard.remark.childSeats', { count: order.childSeat })}`}
              {order.luggage > 0 && ` ${t('orderCard.remark.luggage', { count: order.luggage })}`}
              {order.passengerRemark}
            </span>
          </div>
        )}
        
        <div className="info-item">
          <span className="label">{t('orderCard.label.amount')}:</span>
          <span className="value price">¥{order.price}</span>
        </div>
        
        {type === 'record' && (
          <div className="info-item">
            <span className="label">{t('orderCard.label.paymentStatus')}:</span>
            <span className="value">{order.paymentStatus === 1 ? t('orderCard.payment.paid') : t('orderCard.payment.unpaid')}</span>
          </div>
        )}
      </div>

      <div className="order-actions">
        {type === 'hall' && order.paymentStatus === 1 && (
          <button 
            className="accept-btn" 
            onClick={() => onAction(order.orderId)}
          >
            {t('orderCard.action.grabOrder')}
          </button>
        )}
        
        {type === 'record' && (
          <>
            {onChat && (
              <img 
                src={messagePng} 
                alt={t('orderCard.action.contactPassenger')} 
                onClick={() => onChat(order.orderId)} 
              />
            )}
            <button 
              className="call-btn"
              onClick={() => window.location.href = `tel:${order.passengerPhone}`}
            >
              {t('orderCard.action.contactPassenger')}
            </button>
            {getActionButton(order.orderStatus) && (
              <button 
                className="update-status-btn" 
                onClick={() => onAction(order.orderId, getActionButton(order.orderStatus).nextStatus)}
              >
                {getActionButton(order.orderStatus).text}
              </button>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default OrderCard;
